(function () {
    'use strict';

    function loadLvSubcollectionImages(root) {
        root = root || document;

        var images = root.querySelectorAll(
            'img.lv-subcollection-image-placeholder[data-lv-image]:not([src])'
        );

        images.forEach(function (img) {
            var filename = img.getAttribute('data-lv-image');

            if (!filename) return;

            img.src = '/cdn/shop/files/' + encodeURIComponent(filename);
            img.loading = 'eager';
            img.fetchPriority = 'high';
        });
    }

    // Első oldalbetöltés
    loadLvSubcollectionImages(document);

    // Ella AJAX / dinamikus DOM-cserék
    var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            mutation.addedNodes.forEach(function (node) {
                if (node.nodeType !== 1) return;

                if (
                    node.matches &&
                    node.matches('img.lv-subcollection-image-placeholder[data-lv-image]:not([src])')
                ) {
                    loadLvSubcollectionImages(node.parentNode || document);
                } else if (node.querySelector) {
                    loadLvSubcollectionImages(node);
                }
            });
        });
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
    // FALSE subcollection UI-navigáció
document.addEventListener('click', function (event) {
    var link = event.target.closest('.lv-subcollection-nav');

    if (!link) return;

    var handle = link.getAttribute('data-lv-handle');

    if (!handle) return;

    window.location.href = '/collections/' + encodeURIComponent(handle);
});

// Billentyűzetes navigáció
document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;

    var link = event.target.closest('.lv-subcollection-nav');

    if (!link) return;

    var handle = link.getAttribute('data-lv-handle');

    if (!handle) return;

    event.preventDefault();
    window.location.href = '/collections/' + encodeURIComponent(handle);
});
})();